import styled from "styled-components";

export const SearchWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const SearchModeContainer = styled.div`
  min-width: 200px;
`;

export const SearchContainer = styled.div`
  flex: 1;
  min-width: 250px;
`;
